import { createApi } from '@reduxjs/toolkit/query/react';
import { getHeaders } from 'auth/auth';
import { baseQueryWithReauth } from '../baseQuery';

export const documentUploadAPI = createApi({
  reducerPath: 'uploadDocs',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    uploadChatDocs: builder.mutation({
      query: ({
        file,
        borrowerId,
        loanApplicationId,
        title,
        tags,
        chatId,
        fileRequestText,
        useConsumerChatWorkflow = false,
        useB2BChatWorkflow = false,
      } = {}) => {
        const formData = new FormData();
        formData.append('file', file);

        if (loanApplicationId) {
          formData.append('loan_application_id', loanApplicationId);
        }
        if (borrowerId) {
          formData.append('borrower_id', borrowerId);
        }
        if (title) {
          formData.append('title', title);
        }
        if (Array.isArray(tags) && tags.length > 0) {
          formData.append('tags', tags.join(','));
        }
        if (chatId) {
          formData.append('chat_id', chatId);
        }
        if (fileRequestText) {
          formData.append('file_request_text', fileRequestText);
        }

        const headers = getHeaders();
        delete headers['Content-Type'];
        delete headers['content-type'];

        return {
          url: useConsumerChatWorkflow
            ? 'b2c/documents/chat/upload'
            : useB2BChatWorkflow
              ? 'b2b/documents/chat/upload'
              : 'b2c/documents/upload',
          method: 'POST',
          headers,
          body: formData,
        };
      },
    }),
  }),
});

export const { useUploadChatDocsMutation } = documentUploadAPI;
